import MachineBoard from "../shared";

export default function MachineStock() {
  return <MachineBoard mode="stock" />;
}
